"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useObservable = void 0;
var react_1 = require("react");
/**
 * Create a memoized observable and unsubscribe automatically if component unmount
 * @returns [observableValue, error, isCompleted]
 */
function useObservable(observableGenerator, deps, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var _a = react_1.useState(null), value = _a[0], setValue = _a[1];
    var _b = react_1.useState(), error = _b[0], setError = _b[1];
    var _c = react_1.useState(false), complete = _c[0], setComplete = _c[1];
    var defaultValueRef = react_1.useRef(defaultValue);
    var cb = react_1.useCallback(observableGenerator, deps);
    react_1.useEffect(function () {
        setValue(defaultValueRef.current || null);
        setError(undefined);
        setComplete(false);
        defaultValueRef.current = null;
        var sub = cb().subscribe(function (data) {
            setValue(data);
            setError(undefined);
        }, function (err) {
            setValue(null);
            setError(err);
        }, function () { return setComplete(true); });
        return function () { return sub.unsubscribe(); };
    }, [cb, defaultValue]);
    return [value, error, complete, undefined];
}
exports.useObservable = useObservable;
